import { Button } from '@coolblue-development/becky';
import { Compare } from '@coolblue-development/icons';

interface TransferButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

const TransferButton = ({ onClick, disabled }: TransferButtonProps): JSX.Element => {
  return (
    <Button
      startIcon={<Compare />}
      onClick={onClick}
      disabled={disabled}
      data-testid="transfer-button"
      preset="secondary"
    >
      Transfer
    </Button>
  );
};

export default TransferButton;
